// import { useQuery } from "react-query";
// import { request } from "../../../config/helpers/axios-instance";

// const GetItemAvailability = (quotationId) => {
//     return useQuery(
//         ["get-item-availability", quotationId],
//         () =>
//             request({
//                 url: `/hinai/userorder/getAvailablityOfItems/${quotationId}`,
//                 method: "GET",
//             }),
//         {
//             enabled: !!quotationId,
//             refetchOnWindowFocus: false,
//             staleTime: 2 * 60 * 1000, // 2 minutes - availability can change
//             cacheTime: 5 * 60 * 1000, // 5 minutes
//         }
//     );
// };

// export { GetItemAvailability };

// src/hooks/fetch-hooks/get-item-availability/get-item-availability.js

// import { useQuery } from "react-query";
// //import { request } from "../../../config/helpers/axios-instance";

// const GetItemAvailability = (quotationId) => {
//     return useQuery(
//         ["get-item-availability", quotationId],
//         () => {
//             // TEMPORARY MOCK DATA - Remove this when ready for real API
//             return Promise.resolve({
//                 data: {


//                     success: true,
//                     data: {
//                         overallAvailablePercentage: 0,
//                         stockAvailability: {
//                             MDRGD16000066: {
//                                 easydoseStore: {
//                                     availableQty: 0,
//                                     isAvailable: false
//                                 },
//                                 opPharmacy: {
//                                     availableQty: 0,
//                                     isAvailable: false
//                                 }
//                             },
//                             MDRGM3101542: {
//                                 easydoseStore: {
//                                     availableQty: 0,
//                                     isAvailable: false
//                                 },
//                                 opPharmacy: {
//                                     availableQty: 270,
//                                     isAvailable: true,
//                                     itemId: 31874581
//                                 }
//                             }
//                         },
//                         costEstimation: 521.855
//                     },
//                     error: ""
//                 }

//             });

//             // UNCOMMENT THIS WHEN READY FOR REAL API:
//             // return request({
//             //     url: `/hinai/userorder/getAvailablityOfItems/${quotationId}`,
//             //     method: "GET",
//             // });
//         },
//         {
//             enabled: !!quotationId,
//             refetchOnWindowFocus: false,
//         }
//     );
// };

// Add a real API call  

import { useQuery } from "react-query";
import { request } from "../../../config/helpers/axios-instance";
import { TENANT_COMPANY_MAP } from "../../../utils/constants";
import { getTenantId } from "../../../utils/helpers";

const GetItemAvailability = (quotationId) => {
    
    const tenantId = getTenantId();
    const isEasydose = process.env.REACT_APP_EASYDOSE_FEATURE_ENABLED === 'true' && tenantId === TENANT_COMPANY_MAP.EAZY;

    return useQuery(
        ["get-item-availability", quotationId],
        () => request({ url: `/hinai/userorder/getAvailablityOfItems/${quotationId}`, method: "GET" }),
        {
            enabled: isEasydose && !!quotationId,
            refetchOnWindowFocus: false,
        }
    );
};

export { GetItemAvailability };